// extracted by mini-css-extract-plugin
export default {"textarea_box":"Textarea_textarea_box__aNimi","texalign_end":"Textarea_texalign_end__bJ6kE","textarea":"Textarea_textarea__bO-5R"};